import Error from 'next/error'
import { PAGINEDETAIL, RIVISTE, SLUG } from 'utils/endpoint'
import { api } from 'utils'
import LandingRivisteTemplate from 'react-components/templates/LandingRivisteTemplate/LandingRivisteTemplate'

const LandingRiviste = ({ rivista, page, statusCode }) => {
  if (!page) return <Error statusCode={statusCode} />
  return <LandingRivisteTemplate rivista={rivista} page={page} />
}

export async function getStaticPaths() {
  const response = await api.get(RIVISTE)
  const riviste = response.data

  const paths = riviste.map(t => ({
    params: { slug: t.slug },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  try {
    const response = await api.get(`${RIVISTE}${SLUG}${slug}/`)
    const rivista = response.data

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'riviste-detail-scopri',
      },
    })
    const page = await pageResponse.data
    const toolbarProps = { toolbarItem: rivista, toolbarPage: page }

    return {
      props: { rivista, page, key: rivista.id, ...toolbarProps },
      revalidate: 60,
    }
  } catch (error) {
    console.log(error)
    return {
      notFound: true,
    }
  }
}

export default LandingRiviste
